<template>
  <div class="insurance">
    <van-dialog v-model="show" title="用户注册协议及用户信息使用须知">
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >一、协议的确认与接受</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >欢迎你使用我们的服务。在你注册成为我们的用户之前，请仔细阅读本《用户注册协议及用户信息使用须知》（以下简称
          “本协议”）。本协议阐述了在你使用我们的服务过程中，关于你的注册及我们对用户信息的使用规定。一旦你点击
          “同意注册”
          按钮，即表示你已充分阅读、理解并接受本协议的所有条款和条件。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >二、用户注册</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >你在注册时需提供真实、准确、完整的个人信息，包括但不限于姓名、电子邮箱、手机号码等。若你提供的信息不真实、不准确或不完整，我们有权暂停或终止你的用户资格。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >你应妥善保管自己的注册账号和密码，不得将其转让、出售或借给他人使用。如因你保管不善导致账号和密码被他人非法使用，你应承担由此产生的一切后果。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >三、用户信息的收集与使用</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >我们会在你注册及使用我们的服务过程中收集你的个人信息，包括但不限于你的姓名、性别、年龄、联系方式、浏览记录、消费记录等。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >我们收集这些信息的目的是为了更好地为你提供服务，包括但不限于个性化推荐、客户服务、市场调研等。我们会严格按照法律法规的要求，对收集到的用户信息进行保密，不会将其用于任何非法目的。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >我们可能会将你的个人信息与第三方合作伙伴共享，但仅限于为了向你提供更好的服务或履行法律义务的目的。在共享你的信息之前，我们会确保第三方合作伙伴遵守与我们相同的隐私保护政策。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >四、用户信息的安全</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >我们采取了一系列技术和管理措施来保护你的用户信息安全，包括但不限于数据加密、访问控制、安全审计等。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >尽管我们已经采取了上述安全措施，但由于互联网的开放性和不可预测性，我们不能保证你的用户信息绝对安全。如发生用户信息泄露事件，我们将及时通知你，并采取相应的补救措施。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >五、用户的权利与义务</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >你有权随时访问、修改、删除你的个人信息。你可以通过我们的网站或客户端的相关功能进行操作。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >你有义务及时更新你的个人信息，确保其真实、准确、完整。如因你提供的信息不真实、不准确或不完整导致我们无法为你提供服务，我们不承担任何责任。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >你不得利用我们的服务从事任何违法、违规或侵犯他人权益的活动。如你违反本协议的规定，我们有权暂停或终止你的用户资格，并追究你的法律责任。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >六、协议的变更与终止</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >我们有权随时修改本协议的条款和条件。修改后的协议将在我们的网站或客户端上公布，自公布之日起生效。如果你继续使用我们的服务，即表示你接受修改后的协议。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >如果你违反本协议的任何条款和条件，我们有权暂停或终止你的用户资格。在终止你的用户资格后，我们将停止为你提供服务，并删除你的用户信息。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >七、法律适用与争议解决</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >如你与我们在本协议的履行过程中发生争议，双方应首先通过友好协商解决。协商不成的，任何一方均可向有管辖权的人民法院提起诉讼。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >八、其他条款</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >本协议的标题仅为方便阅读而设，不具有任何法律意义。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >本协议的条款和条件构成你与我们之间的完整协议，取代你与我们之前就相同事项达成的任何口头或书面协议。</span
        >
      </p>
      <br />
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 28px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >再次感谢你选择我们的服务，我们将竭诚为你提供优质、安全的服务体验。</span
        >
      </p>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="less" scoped>
.insurance {
  /deep/.van-dialog__header {
    color: #323233;
    font-weight: 700;
    font-size: 17px;
  }
  /deep/.van-dialog__content {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    max-height: 60vh;
    padding: 8px 24px 26px 24px;
    overflow-y: auto;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
    text-align: center;
    word-wrap: break-word;
    -webkit-overflow-scrolling: touch;
  }
}
</style>